import { __awaiter, __generator } from "tslib";
export function resolveConfigValue(value) {
    return __awaiter(this, void 0, Promise, function () {
        return __generator(this, function (_a) {
            if (typeof value === 'function') {
                // eslint-disable-next-line @typescript-eslint/ban-types
                return [2 /*return*/, value()];
            }
            return [2 /*return*/, value];
        });
    });
}
